import React, { useState, useEffect } from "react";
import SectionKelolaField from "components/CrudUserSetup/SectionKelolaField";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import AlertDialog from "../../../components/Feedback/AlertDialog";

import {
  getAllSubAgents,
  createSubAgent,
  updateSubAgent,
  deleteSubAgent,
} from "../../../services/subAgentService";

const SubAgentSetupLapak = () => {
  const [subAgents, setSubAgents] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const normalizeArray = (res) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data?.data)) return res.data.data;
    return [];
  };

  // Load data pertama kali
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllSubAgents();
        const mapped = normalizeArray(res)
          .filter((s) => s.status_sa.toLowerCase() === "lapak") // hanya lapak
          .map((s) => ({
            id: s.id,
            name: s.name,
            codeSA: s.code_sa,
            nameOwner: s.name_owner,
            region: s.region,
            statusSA: s.status_sa,
          }));
        setSubAgents(mapped);
      } catch (err) {
        console.error("Gagal memuat data sub agent:", err);
      }
    };

    fetchData();
  }, []);

  // CREATE
  const handleAdd = async (value) => {
    try {
      const res = await createSubAgent({
        ...value,
        statusSA: "lapak", // status default lapak
      });
      const newItem = normalizeArray(res)[0] ?? res?.data ?? res;

      setSubAgents((prev) => [
        {
          id: newItem.id,
          name: newItem.name,
          codeSA: newItem.code_sa,
          nameOwner: newItem.name_owner,
          region: newItem.region,
          statusSA: newItem.status_sa,
        },
        ...prev,
      ]);
      setAlertMessage("Sub Agent Lapak berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah sub agent:", err);
    }
  };

  // UPDATE
  const handleEdit = async (item) => {
    try {
      const res = await updateSubAgent(item.id, {
        ...item,
        statusSA: "lapak", // tetap dikirim lapak
      });
      const updated = normalizeArray(res)[0] ?? res?.data ?? res;

      setSubAgents((prev) =>
        prev.map((p) =>
          p.id === updated.id
            ? {
                id: updated.id,
                name: updated.name,
                codeSA: updated.code_sa,
                nameOwner: updated.name_owner,
                region: updated.region,
                statusSA: updated.statusSA,
              }
            : p
        )
      );
    } catch (err) {
      console.error("Gagal mengedit sub agent:", err?.response?.data ?? err);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;

    try {
      await deleteSubAgent(selectedDeleteItem.id);
      setSubAgents((prev) =>
        prev.filter((p) => p.id !== selectedDeleteItem.id)
      );
    } catch (err) {
      console.error("Gagal menghapus sub agent:", err);
    } finally {
      setIsConfirmOpen(false);
      setSelectedDeleteItem(null);
    }
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Sub Agent Lapak
      </h1>

      <div className="w-full">
        <SectionKelolaField
          //title="Sub Agent Lapak"
          data={subAgents}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setIsConfirmOpen(true);
          }}
          fields={[
            { key: "name", label: "Nama Agen", className: "flex-1" },
            {
              key: "codeSA",
              label: "Kode Agen",
              className: "flex-1 text-center",
            },
            { key: "nameOwner", label: "Nama Pemilik", className: "flex-1" },
            { key: "region", label: "Wilayah", className: "flex-[2]" },
          ]}
        />
      </div>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Hapus Sub Agent"
        message="Apakah Anda yakin ingin menghapus sub agent ini?"
      />
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => setIsAlertOpen(false)}
          title="Berhasil"
          message={alertMessage}
        />
      )}
    </div>
  );
};

export default SubAgentSetupLapak;
